import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

const PhonepeFailed = () => {


    const navigate = useNavigate();

    const time = setTimeout(() => {
        navigate('/')
    }, 10000);


    const [data, setData] = useState({})
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const transactionId = urlParams.get('transaction_id');
        const amount = urlParams.get('amount');
        setData({ 'transactionId': transactionId, 'amount': amount })
    }, []);



    return (
        <div className="main-container">
            <div className="check-container">
                <div className="check-background-failed">
                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="225.000000pt" height="225.000000pt"
                        viewBox="0 0 225.000000 225.000000" preserveAspectRatio="xMidYMid meet">

                        <g transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none">
                            <path d="M497 1753 l-123 -123 248 -247 c137 -136 248 -252 248 -258 0 -6
                       -111 -122 -248 -258 l-248 -247 123 -123 123 -123 247 248 c136 137 252 248
                       258 248 6 0 122 -111 258 -248 l247 -248 123 123 123 123 -248 247 c-137 136
                       -248 252 -248 258 0 6 111 122 248 258 l248 247 -123 123 -123 123 -247 -248
                       c-136 -137 -252 -248 -258 -248 -6 0 -122 111 -258 248 l-247 248 -123 -123z" />
                        </g>
                    </svg>

                </div>
                <div className="check-shadow-failed"></div>
            </div>
            <h2 className="">Payment Failed</h2>
            <div className="pament-table">
                <div className="pament-table">

                    <div className="pb-20 payment-wrapper">
                        <span className="id-title">Transaction Id</span>
                        <span className="dot ">:</span>
                        <span className="id-value">{data?.transactionId}</span>
                    </div>
                    <div className="payment-wrapper">
                        <span className="id-title">Amount</span>
                        <span className="dot ">:</span>
                        <span className="id-value">{data?.amount}</span>
                    </div>

                </div>
            </div>
            <p className="message"> Do not refresh or close this window.<br /> You will be redirected to Taskde.</p>
        </div>
    )
}

export default PhonepeFailed;